module.exports = __webpack_public_path__ + "img/right-arm.d836444b.png";